class ProductCardLink extends HTMLElement {
  connectedCallback() { this.addEventListener('click', this.handleClick, true); }
  disconnectedCallback() { this.removeEventListener('click', this.handleClick, true); }
  handleClick = (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        this.dataset.productTransition !== 'true' || window.EidoMotion?.reduced()) return;
    const target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest('button, input, label, select, textarea, [role="button"]')) return;
    const link = target.closest('a[href]') || this.querySelector('a[ref="productCardLink"]');
    if (!link || link.download || (link.target && link.target !== '_self') || link.origin !== location.origin || link.hash || !link.pathname.includes('/products/')) return;
    const image = this.querySelector('slideshow-slide[aria-hidden="false"] img[transitionToProduct]') ||
      this.querySelector('[data-view-transition-to-main-product] img[transitionToProduct]');
    if (!image?.complete || !image.naturalWidth) return;
    document.querySelectorAll('[data-eido-transition-image]').forEach(el => el.removeAttribute('data-eido-transition-image'));
    image.setAttribute('data-eido-transition-image', '');
    image.dataset.eidoTransitionUrl = link.href;
  };
}
if (!customElements.get('product-card-link')) customElements.define('product-card-link', ProductCardLink);
